module.exports = __webpack_public_path__ + "static/media/5.6a7060c3.jpg";